<div theme>
  <dxc-select
    tooltipCustom
    label="{{ label() | translate }}"
    placeholder="{{ placeholder() | translate }}"
    [margin]="margin()"
    [options]="options()"
    (onChange)="onChange($event)"
    (onBlur)="onBlur($event)"
    [size]="size()"
    [value]="value"
    [searchable]="searchable()"
    [multiple]="multiple()"
    [error]="_errorMessage"
    [disabled]="disabled"
    [class.required]="required() === true"
  >
  </dxc-select>
</div>
<!-- [title]="getSelectedLabel(value)" -->
